<template>
  <section class="section">
    <h3>
      {{ $t('message.disease_map') }}
      <div class="subtitle">{{ $t('message.disease_map_subtitle') }}</div>
    </h3>
    <div class="container">
      <div class="map" ref="map"></div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/map'
import jpGeoJSON from 'ncovjp-data/jp-all.geo.json'
import onresize from '@/libraries/onresize'

echarts.registerMap('Japan', jpGeoJSON)

export default {
  name: 'Map',
  computed: {
    ...mapState({
      data: function (state) {
        return [
          ...Object.values(this.$t('prefecture', 'jp')).map((name) => ({
            name,
            value: 0,
          })),
          ...(state.visions.map || []).map((row) => ({
            name: row.prefecture,
            value: row.confirmed,
          })),
        ]
      },
    }),
  },
  methods: {
    paint () {
      const chart = echarts.init(this.$refs.map, 'darkmap')

      chart.setOption({
        visualMap: {
          min: 0,
          max: 40,
          pieces: [
            { gte: 30 },
            { gte: 20, lte: 29 },
            { gte: 10, lte: 19 },
            { gte: 1, lte: 9 },
            { value: 0 },
          ],
        },
        series: [
          {
            type: 'map',
            mapType: 'Japan',
            emphasis: {
              label: {
                formatter: this.$t('message.disease_map_emphasis'),
              },
            },
            data: this.data,
            nameMap: this.$t('prefecture', 'jp'),
          },
        ],
      })

      this.chartInstances = [ chart ]
    },
  },
  mounted() {
    this.offresize = onresize(() => (this.chartInstances || []).forEach((chart) => chart.resize()))
  },
  beforeDestroy () {
    this.offresize()
  },
  watch: {
    data () {
      this.paint()
    },
    '$i18n.locale' () {
      this.paint()
    },
  },
}
</script>

<style lang="less" scoped>
.section {
}
.container {
  position: relative;
  width: 100%;
  height: 480px;
}
h3 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  line-height: 1em;
  margin: 1em 0;
  padding: 0;
  .subtitle {
    color: #ccc;
    font-size: 12px;
    font-weight: normal;
    line-height: 1em;
    padding-top: 1em;
  }
  // color: #333;
  // font-size: 24px;
  // font-weight: bold;
  // margin: 1.5em 0 0;
  // padding: 0;
}
.map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
</style>
